import styled from '@emotion/styled';
import { Button, Popover } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import { ColorPickerPopover } from './ColorPickerPopover';

const StyledButton = styled(Button)<{ dimension: string; bg: string }>`
    padding: 0px;
    height: ${({ dimension }) => dimension};
    min-width: ${({ dimension }) => dimension};
    max-width: ${({ dimension }) => dimension};
    color: transparent !important;
    border: ${({ theme }) => `1px solid ${theme.colors.black[200]}`};
    background-color: ${({ bg }) => bg};

    &:hover {
        background-color: ${({ bg }) => bg};
    }
`;

const paperProps = {
    sx: {
        '&:focus': {
            outline: 'none',
            border: 'none',
        },
        margin: '2px',
        padding: '0px',
        borderRadius: '8px',
    },
};

interface Props {
    value: string;
    onChange: (color: string) => void;
    size: string;
    children?: ReactNode;
    predefinedColors?: string[];
}

export const ColorPicker = ({ value, onChange, size, children, predefinedColors }: Props) => {
    const [colorPickerTooltip, setColorPickerTooltip] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setColorPickerTooltip(event.currentTarget);
    };

    return (
        <>
            <StyledButton onClick={handleClick} dimension={size} bg={value}>
                {children}
            </StyledButton>
            <Popover
                id="color-popover"
                open={!!colorPickerTooltip}
                anchorEl={colorPickerTooltip}
                onClose={() => setColorPickerTooltip(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                slotProps={{ paper: paperProps }}>
                <ColorPickerPopover
                    setColor={onChange}
                    color={value}
                    setClose={() => setColorPickerTooltip(null)}
                    predefinedColors={predefinedColors}
                />
            </Popover>
        </>
    );
};
